export default __webpack_public_path__ + "static/loading-background-9297fc34eb6b37c74792d58f8fd25ca1.png";